import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Card, Spinner, Alert } from 'react-bootstrap';
import logoImage from '../assets/HiveMind_Logo.png';

function ForgotPassword({ onBackToLogin }) {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!email) {
            setError('Please enter your email or username');
            return;
        }

        setLoading(true);
        setError(null);
        setSuccess(false);

        try {
            const response = await fetch('/api/auth/forgot-password.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: email,
                }),
            });

            const data = await response.json();

            if (data.status === 'success') {
                setSuccess(true);
                setEmail('');
            } else {
                setError(data.message || 'Failed to send password reset email');
            }
        } catch (err) {
            setError('Network error: ' + err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-page-container">
            {/* Background blur effects */}
            <div className="bg-blur-indigo"></div>
            <div className="bg-blur-fuchsia"></div>
            
            <Container className="py-5 login-page-content">
                <Row className="justify-content-center">
                    <Col md={6} lg={4}>
                        <Card className="glass">
                            <Card.Body>
                                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
                                    <img src={logoImage} alt="HiveMind Logo" className="login-logo" style={{ width: '90px', height: 'auto' }} />
                                </div>
                                <Card.Title className="text-center mb-4 login-title">Forgot Password</Card.Title>
                                <Card.Text className="text-center mb-4 login-subtitle">
                                    Enter your email or username and we'll send you a password reset link
                                </Card.Text>
                                
                                {success ? (
                                    <Alert variant="success" className="mb-3">
                                        <Alert.Heading>Email Sent</Alert.Heading>
                                        <p className="mb-0">If an account exists, a password reset link has been sent to your email address.</p>
                                    </Alert>
                                ) : (
                                    <Form onSubmit={handleSubmit}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className="login-label">Email or Username</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Enter email or username"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                autoCapitalize="none"
                                                className="login-input"
                                                disabled={loading}
                                            />
                                        </Form.Group>
                                        
                                        {error && (
                                            <Alert variant="danger" className="mb-3">
                                                {error}
                                            </Alert>
                                        )}
                                        
                                        <Button
                                            variant="primary"
                                            size="lg"
                                            className="w-100"
                                            type="submit"
                                            disabled={loading}
                                            style={{
                                                background: '#6366f1',
                                                borderColor: '#6366f1'
                                            }}
                                        >
                                            {loading ? (
                                                <>
                                                    <Spinner animation="border" size="sm" className="me-2" />
                                                    Sending...
                                                </>
                                            ) : (
                                                'Send Reset Link'
                                            )}
                                        </Button>
                                    </Form>
                                )}
                                
                                <div className="text-center mt-3">
                                    <Button
                                        variant="link"
                                        onClick={onBackToLogin}
                                        className="login-link"
                                        style={{ padding: 0 }}
                                    >
                                        Back to Login
                                    </Button>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default ForgotPassword;


